import { render, staticRenderFns } from "./BarDossiersByMaladieProChart.vue?vue&type=template&id=63f24ef2&"
import script from "./BarDossiersByMaladieProChart.vue?vue&type=script&lang=ts&"
export * from "./BarDossiersByMaladieProChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports